import ShiplexLogo from '@/components/ui/ShiplexLogo';

import { Breadcrumbs } from './components/Breadcrumbs';
import { SearchBar } from './components/SearchBar';
import { ThemeToggle } from './components/ThemeToggle';
import { UserTile } from './components/UserTile';
import { useHeaderSlot } from './context/HeaderSlotContext';

export const Header: React.FC = () => {
  const { rightSlot } = useHeaderSlot();

  return (
    <header className="bg-secondary-600 border-border-500/40 grid h-14 grid-cols-[1fr_auto_1fr] items-center border-b shadow-sm">
      <div className="ml-3 flex min-w-0 items-center xl:ml-6">
        <div className="flex h-6 w-auto shrink-0 items-center">
          <ShiplexLogo color="duotoneWhite" className="h-6 w-auto" />
        </div>
        <Breadcrumbs />
      </div>
      <div className="w-65 xl:w-100">
        <SearchBar />
      </div>
      <div className="flex shrink-0 items-center justify-end gap-2">
        {rightSlot}
        <ThemeToggle />
        <UserTile />
      </div>
    </header>
  );
};
